// Mock data for Numerounosounds website

export const artists = [
  {
    id: 1,
    name: "Certified Dan",
    role: "Director / Co-Producer / DJ",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/4xdo5viv_192841.jpg",
    bio: "Certified Dan is the founder and director of Numero Uno Sounds, the independent platform built to support emerging drum & bass talent. A true rave veteran, Dan's journey began in the early '90s on the dancefloor, captivated by the raw energy of the underground scene. His passion evolved quickly — stepping up as a DJ, spinning at illegal raves and pirate radio stations across Essex and beyond. His first big breakthrough came at the Battle of the DJs for Area 51 Records in Braintree, launching Double D and Double Trouble events in Bury St Edmunds and Southend. He became a resident DJ for major brands, repping for Drumsound & Bassline Smith, Interface Derby, and smashing sets at major UK events including Slammin' Vinyl and Pleasuredome. Radio has always been in his blood — from Lush and Mystery FM to Obsession, Pure FM, and Global DnB. He even ran his own station, Fenz FM, broadcasting out of Cambridgeshire. Today, Certified Dan is the driving force behind Numero Uno Sounds — his own label with global releases and a mission to push DnB, Jungle, and Old Skool sounds forward. Whether producing tracks, running events like Jump Up in the Jungle, or tearing up the decks, Certified Dan is built for this. Jungle is in his DNA. The rave runs through his veins. Certified by name, fire by nature. He hosts The Numero Uno Show on Pure FM every Tuesday (7–9pm), showcasing new releases, exclusive material, and supporting the wider scene. As co-producer with Lost in Bass, he contributes ideas, direction, and creative input, forming a partnership built on trust, loyalty, and shared ambition. His role represents the backbone of Numero Uno — structure, persistence, and belief in the vision. If you're an artist looking to be part of the movement, Numero Uno is always open to hearing new talent. Producers and DJs who share the same passion, energy, and mindset are encouraged to send demos — with the goal of building a strong team and pushing the sound forward together.",
    liveShow: "Pure FM - The Numero Uno Show, Tuesdays 7 - 9 PM",
    radioUrl: "https://purefmuk.com",
    social: {
      instagram: "https://instagram.com/certifieddan",
      tiktok: "https://www.tiktok.com/@numerounosounds?_r=1&_t=ZN-9479b0QrFXa",
      facebook: "https://www.facebook.com/share/182gp49RtR/"
    }
  },
  {
    id: 2,
    name: "Lost in Bass",
    role: "Co-Owner & Producer / DJ",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/6lyc1axt_192871.jpg",
    bio: "Lost in Bass is a drum & bass and jungle producer and DJ known for heavy, dark, powerful music and an unusually fast progression that has set him apart from the very beginning. His connection to rhythm started long before production or DJing. Even as a child, he showed a natural sensitivity to timing and structure — noticing when things were slightly ahead or behind the beat, even matching the speed of car windscreen wipers to the tempo of music playing on the radio. That instinctive understanding of rhythm would later become the foundation of both his DJing and production ability. At 17 years old, he stepped onto vinyl decks for the first time and immediately demonstrated an ear for beat-matching that normally takes months or years to develop. Within minutes he was aligning tempos purely by ear, recognising when the headphones were slower than the speakers and adjusting until the mix locked in — confirming a natural musical instinct from the outset. Production followed the same pattern of rapid progression. His first track, The Beginning, was created in roughly 10–15 hours of total work across a couple of weeks and was already strong enough in quality to be considered record-label worthy — something highly unusual for a first production. From that point forward, his sound evolved quickly into a distinctive style built around weight, impact, and movement. Rather than staying repetitive or predictable, Lost in Bass focuses on music that evolves — with switches, drops, and transitions that keep energy flowing while maintaining structure. The result is a recognisable signature sound early in his career: hard-hitting, heavy tracks driven by instinct and feeling. The response to his music has been exceptionally strong. Since releasing tracks, the feedback has been entirely positive, with listeners consistently reacting to both the power and atmosphere within his productions — something rare for any artist, particularly within the first year of producing. More notably, reactions often go far beyond typical comments. Listeners have described his music with statements such as: 'This is the best tune I've heard this year.' 'You're my favourite producer right now.' 'I need your autograph when you make it.' 'Your music takes me somewhere else.' These responses highlight not only technical quality, but the impact his sound creates with listeners — a defining trait of his work. Alongside production, Lost in Bass performs DJ sets and regularly streams live on TikTok every Sunday from 6–8pm, showcasing drum & bass, jungle, and his own unreleased material to a growing audience. With a natural musical instinct, rapid development, and a clear artistic identity already forming, Lost in Bass represents a new wave of producer — driven by instinct, energy, and authenticity rather than formula. Don't take our word for it — see what people are saying below.",
    liveShow: "TikTok Live every Sunday, 6:00 - 8:00 PM",
    social: {
      instagram: "https://www.instagram.com/djlostinbass?igsh=bjVueGhsM2lhamxi",
      tiktok: "https://tiktok.com/@lostinbass_official"
    }
  }
];

export const releases = [
  {
    id: 1,
    title: "Paradox",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/wjeoexcy_193796.jpg",
    releaseDate: "2026-08-28",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZN8RfsdjL/",
    comingSoon: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "Earthquake - Rewrite",
    artist: "Lost in Bass",
    artwork: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/jhxe66co_193793.jpg",
    releaseDate: "2026-08-21",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZN8RftxET/",
    comingSoon: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "The Time Reactor",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/vftxb4ws_192865.jpg",
    releaseDate: "2026-08-14",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZN8dGhGtX/",
    comingSoon: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "BROKEN",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/lx266th6_184851.jpg",
    releaseDate: "2026-04-15",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRKE3nbN/",
    comingSoon: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "The Lost Concept 3",
    artist: "Lost in Bass",
    artwork: "https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/lh461lgl_195571.jpg",
    releaseDate: "2026-01-01",
    bpm: 175,
    genre: "Jungle",
    tiktokUrl: "https://vm.tiktok.com/ZN88q3tdq/",
    isBootleg: true,
    vipExclusive: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "The Lost Concept 2",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/g5q195om_180073.jpg",
    releaseDate: "2026-01-01",
    bpm: 175,
    genre: "Jungle",
    tiktokUrl: "https://vm.tiktok.com/ZNR3fcpWu/",
    isBootleg: true,
    vipExclusive: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "The Lost Concept 1",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/prdtq1te_137661.jpg",
    releaseDate: "2026-01-01",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPv2bYf/",
    isBootleg: true,
    vipExclusive: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "David Guetta - On My Love",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/11h97auy_161761.jpg",
    releaseDate: "2026-04-09",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRqTpot7/",
    isBootleg: true,
    streamingLinks: {}
  },
  {
    id: 2,
    title: "S1D3TRAK - Motive",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/wgcwcp65_161759.jpg",
    releaseDate: "2026-04-24",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRqTXp3n/",
    comingSoon: true,
    streamingLinks: {}
  },
  {
    id: 3,
    title: "The Weeknd - The Hills",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/swi8276z_161757.jpg",
    releaseDate: "2026-04-07",
    bpm: 175,
    genre: "Jungle Bootleg Remix",
    tiktokUrl: "https://vm.tiktok.com/ZNRqTa6Dt/",
    isBootleg: true,
    streamingLinks: {}
  },
  {
    id: 4,
    title: "Hurt Me",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/t4ppyjhb_161755.jpg",
    releaseDate: "2026-04-06",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRqTVSdb/",
    streamingLinks: {}
  },
  {
    id: 5,
    title: "The Darkness",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/ywglrs3b_154826.jpg",
    releaseDate: "2026-01-15",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPKudcL/",
    streamingLinks: {}
  },
  {
    id: 6,
    title: "Take Me Deeper",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/l2rojua0_154824.jpg",
    releaseDate: "2026-01-10",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPKkBBa/",
    streamingLinks: {}
  },
  {
    id: 4,
    title: "Gunshot in the Dark VIP",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/40vpd8wh_137665.jpg",
    releaseDate: "2026-02-20",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPtPaQ1/",
    streamingLinks: {
      beatport: "https://beatport.com/release/Gunshot%20in%20the%20Dark%20Vip/5927652",
      spotify: "https://open.spotify.com/track/51s5eS8dSjBgdXHQRT4hAf",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 5,
    title: "I Finally See",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/k8fvs241_137667.jpg",
    releaseDate: "2026-02-06",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPthnkH/",
    streamingLinks: {
      beatport: "https://beatport.com/track/I%20Finally%20See%20(Original%20Mix)/23918825",
      spotify: "https://open.spotify.com/album/4AYu6PM7u32I82AP3AyOTj",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 6,
    title: "Rise Up",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/suthngrp_137663.jpg",
    releaseDate: "2026-01-16",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPtfg5f/",
    streamingLinks: {
      beatport: "https://beatport.com/release/Rise%20Up/5789277",
      spotify: "https://open.spotify.com/track/1ffQsQen20OHUikc24sbGA",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 7,
    title: "Cold Like Winter",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/hzuhffua_137671.jpg",
    releaseDate: "2025-12-19",
    bpm: 172,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNR5G43Br/",
    streamingLinks: {
      beatport: "https://beatport.com/release/Cold%20Like%20Winter/5729794",
      spotify: "https://open.spotify.com/track/2fIZ0hOWr7F6Ci0ChgS0ra",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 10,
    title: "Fire Within",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/w5yww8iu_137673.jpg",
    releaseDate: "2025-11-21",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPtMVhG/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Fire%20Within%20(Original%20Mix)/22471094",
      spotify: "https://open.spotify.com/track/26ePPX8c7pwbJ4c1WPiaob",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 11,
    title: "Revival",
    artist: "Lost in Bass The Lyricist",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/ebm8b22s_137677.jpg",
    releaseDate: "2025-11-14",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPtBoQJ/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Revival%20(feat.%20TheLyricist)%20(feat.%20TheLyricist)/22411047",
      spotify: "https://open.spotify.com/track/4xMOpnvFZwYW6OakV5C4Gf",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 12,
    title: "Lost My Heart",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/dmia9f64_137675.jpg",
    releaseDate: "2025-11-01",
    bpm: 172,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNR5GgsXA/",
    streamingLinks: {
      beatport: "https://beatport.com/release/Lost%20My%20Heart/5537780",
      spotify: "https://open.spotify.com/track/6Z5LO1qSsWx9MfUSTD4JhX",
      amazon: "https://music.amazon.com",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 13,
    title: "Take Me Away",
    artist: "Chase & Status (Lost in Bass Bootleg)",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/ej4qahin_137669.jpg",
    releaseDate: "2025-09-18",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPtdujD/",
    isBootleg: true,
    streamingLinks: {}
  },
  {
    id: 14,
    title: "Needing U",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/rropfi0k_137884.jpg",
    releaseDate: "2025-09-12",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTDw9X/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Needing%20U%20(Original%20Mix)/21665274",
      spotify: "https://open.spotify.com/album/32ykWe5rVLteyhOlUhr4Pm",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 15,
    title: "Jeff",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/rxgi5rql_137878.jpg",
    releaseDate: "2025-09-05",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTCE3M/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/3cdAaKha40Q15pdrtvWKHv",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 16,
    title: "Original Jungle Soldier",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/jjsnhkgv_137890.jpg",
    releaseDate: "2025-08-10",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPT4y6J/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/7ezjC5vxeOXbsYJHFQeYcX",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 17,
    title: "Suicidal",
    artist: "Lost in Bass & The Lyricist",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/d1mrryyt_137880.jpg",
    releaseDate: "2025-08-01",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTyF1J/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Suicidal%20(feat.%20TheLyricist)%20(feat.%20TheLyricist)/20893455",
      spotify: "https://open.spotify.com/album/30hAzx2AO85vvh0EUsHmxJ",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 18,
    title: "Cooking",
    artist: "Lost in Bass & Certified Dan feat. Cryo",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/kwm1281k_137882.jpg",
    releaseDate: "2025-07-20",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTqtDy/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/3p6Jqn4gzUPI1hp7pF8mLE",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 19,
    title: "Body Moving",
    artist: "Bear dnb",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/9wk3ku88_138913.jpg",
    releaseDate: "2025-07-18",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPKUuF9/",
    streamingLinks: {
      beatport: "https://beatport.com/release/Body%20Moving/5172474",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 20,
    title: "Bring It Back",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/lqx879ya_137886.jpg",
    releaseDate: "2025-07-04",
    bpm: 172,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPT9BMq/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Bring%20It%20Back%20(Original%20Mix)/20685181",
      spotify: "https://open.spotify.com/album/0PvQgWIJ0e5qzngrFXqTNF",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 21,
    title: "Only Human",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/rtsio5nm_137900.jpg",
    releaseDate: "2025-07-01",
    bpm: 172,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTm794/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/7oUcQe9Szrsu0LWNC1ynDF",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 22,
    title: "Darkest Hour",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/4a5dqn8a_137888.jpg",
    releaseDate: "2025-06-27",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTpULu/",
    streamingLinks: {
      beatport: "https://beatport.com/track/Darkest%20Hour%20(Original%20Mix)/20655148",
      spotify: "https://open.spotify.com/album/2XAPfxz9yiPcM55pl0MWhf",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 23,
    title: "Shut Up Dogs",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/d06bld63_137874.jpg",
    releaseDate: "2025-05-08",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTpRQR/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/2Pd7LxmZp1IUgT6CUqEOgc",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 26,
    title: "Blown Away",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/yoh7smcv_137892.jpg",
    releaseDate: "2025-04-12",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTbar2/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/5iNUM4g9Nw120VOwI3EAvr",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 27,
    title: "Trip Back to Realness",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/7thisao1_137894.jpg",
    releaseDate: "2025-03-20",
    bpm: 173,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTXvb5/",
    streamingLinks: {
      spotify: "https://open.spotify.com/track/11ycKr46XyewAX1yNfhGfj",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 28,
    title: "Your Eyes",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/xkzndkik_137876.jpg",
    releaseDate: "2025-03-05",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTfckh/",
    streamingLinks: {
      spotify: "https://open.spotify.com/track/5gcmEfd6sZDZoBibuRubEx",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 29,
    title: "Gunshot in the Dark",
    artist: "Lost in Bass & Certified Dan",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/qf9w3dfk_137896.jpg",
    releaseDate: "2025-02-10",
    bpm: 175,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTbCnJ/",
    streamingLinks: {
      spotify: "https://open.spotify.com/album/44D2HeEpTg39dS7xSk0rx6",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  },
  {
    id: 30,
    title: "The Beginning",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/u9zq42o6_137898.jpg",
    releaseDate: "2025-01-15",
    bpm: 174,
    genre: "Drum & Bass",
    tiktokUrl: "https://vm.tiktok.com/ZNRPTxpED/",
    streamingLinks: {
      spotify: "https://open.spotify.com/track/3NtvhIScDFRkvQQHBonzja",
      soundcloud: "https://soundcloud.com/lostinbassofficial"
    }
  }
];

// VIP Elite exclusive dubplates
export const dubplates = [
  {
    id: 103,
    title: "The Lost Concept",
    artist: "Lost in Bass",
    artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/prdtq1te_137661.jpg",
    releaseDate: "2026-02-01",
    bpm: 174,
    genre: "VIP Dub",
    tiktokUrl: "https://vm.tiktok.com/ZNRPv2bYf/",
    isBootleg: true
  }
];

export const labelInfo = {
  name: "Numerounosounds",
  tagline: "Underground Drum & Bass",
  description: "Numero Uno Sounds is a cutting-edge drum and bass label built on raw energy, heavy basslines, and authentic underground culture. Founded from a passion for powerful sound and emotional impact, we represent artists who push boundaries and create music that hits both the heart and the dancefloor.",
  established: "2024",
  social: {
    instagram: "https://www.instagram.com/numerounosounds?igsh=cWViaHI2YmJ6NDlp",
    tiktok: "https://www.tiktok.com/@numerounosounds?_r=1&_t=ZN-9479b0QrFXa",
    soundcloud: "https://soundcloud.com/numerounosounds",
    facebook: "https://www.facebook.com/share/182gp49RtR/"
  },
  contact: {
    email: "numerounosounds@proton.me",
    demos: "lostinbass.official@outlook.com"
  }
};
